import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useApp, useAuth } from '../../../contexts';
import useCartStore from '../../../store/useCartStore';
import Logo from './Logo';
import Navigation from './Navigation';
import UserDropdown from './UserDropdown';
import MobileMenu from './MobileMenu';
import {
  HeaderContainer,
  HeaderContent,
  LeftSection,
  HamburgerButton,
} from './Header.style';

const Header = ({ user, onLogout, showBackButton, onBack }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { department, setShowDepartments } = useApp();
  const { user: authUser, isAdmin } = useAuth();
  const { getItemCount } = useCartStore();

  const cartCount = getItemCount();
  const displayName = department?.name || user || t('user');

  const navItems = [
    { label: t('searchPage'), path: '/search', icon: 'mdi-magnify' },
    { label: t('documentsPage'), path: '/documents', icon: 'mdi-file-document' },
    { label: t('ordersPage'), path: '/orders', icon: 'mdi-package-variant' },
    { label: t('cartPage'), path: '/cart', icon: 'mdi-cart', badge: true },
  ];

  const adminItems = [
    { path: '/statistics', icon: 'mdi-chart-box-outline', label: t('statistics') },
    { path: '/notifications', icon: 'mdi-bell-outline', label: t('notifications') },
    { path: '/pricelists', icon: 'mdi-tag-multiple-outline', label: t('priceLists') },
    { path: '/admin-documents', icon: 'mdi-folder-upload-outline', label: t('documentManagement') },
  ];

  const isActive = (path) => location.pathname.startsWith(path);
  const handleNavigation = (path) => history.push(path);
  const handleBackClick = () => (onBack ? onBack() : history.goBack());

  return (
    <>
      <HeaderContainer>
        <HeaderContent>
          <LeftSection>
            <Logo
              onNavigateHome={() => handleNavigation('/search')}
              showBackButton={showBackButton}
              onBack={handleBackClick}
              backLabel={t('back')}
            />
          </LeftSection>

          <Navigation
            items={navItems}
            isActive={isActive}
            onNavigate={handleNavigation}
            cartCount={cartCount}
          />

          <UserDropdown
            displayName={displayName}
            departmentName={department?.name}
            email={authUser?.email}
            isAdmin={isAdmin}
            adminItems={adminItems}
            onAdminNavigate={handleNavigation}
            onChangeDepartment={() => setShowDepartments(true)}
            onLogout={onLogout}
          />

          <HamburgerButton onClick={() => setMobileMenuOpen(true)} aria-label={t('menu')}>
            <i className="mdi mdi-menu" />
          </HamburgerButton>
        </HeaderContent>
      </HeaderContainer>

      <MobileMenu
        isOpen={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        navItems={navItems}
        isActive={isActive}
        onNavigate={handleNavigation}
        cartCount={cartCount}
        displayName={displayName}
        email={authUser?.email}
        isAdmin={isAdmin}
        adminItems={adminItems}
        onChangeDepartment={() => setShowDepartments(true)}
        onLogout={onLogout}
      />
    </>
  );
};

Header.propTypes = {
  user: PropTypes.string,
  onLogout: PropTypes.func,
  showBackButton: PropTypes.bool,
  onBack: PropTypes.func,
};

export default Header;
